import React, { useState, useEffect, useContext } from 'react';
// import React, { useState, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './StickyHeader.scss';
import PrevArrow from '../../../../assets/smartxonnect/PrevArrow.svg';
import { LayoutDetailsContext } from '../../../Project/Layouts/LayoutDetailsContext';
import RequestCallBack from '../RequestCallBackComponent/RequestCallBack';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const HeaderSection = (props) => {
  console.log('Header Props:', props);

  const brandName = useContext(LayoutDetailsContext);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = (e) => {
    e.preventDefault();
    setIsPopupOpen(true);
  };

  return (
    <section className="sticky-header">
      <Container fluid className="header-container">
        <Row className="header-row">
          <Col className="header-col">
            <div className="header-content">
              <div className="left-content">
                <img
                  className="back-button"
                  src={PrevArrow}
                  alt="Back"
                  onClick={() => (window.location.href = props.fields?.BackButtonCta?.value?.href)}
                />

                <a href={props.fields?.BackButtonCta?.value?.href} className="logo-link">
                  <img
                    className="logo"
                    src={props.fields?.HeaderIcon?.value?.src}
                    alt={props.fields?.HeaderIcon?.value?.alt}
                  />
                </a>

                <div className="models-text">
                  <h1>{props.fields?.heading?.value}</h1>
                </div>

                <button className="request-button-mobile" onClick={openPopup}>
                  Request CallBack
                </button>
              </div>

              <div className="right-content">
                <button className="header-button request-button" onClick={openPopup}>
                  Request CallBack
                </button>

                <a
                  href={props.fields?.BookiQubeCta?.value?.href}
                  className="header-button book-button"
                  target={props.fields?.BookiQubeCta?.value?.target || '_self'}
                  rel="noopener noreferrer"
                  onClick={() =>
                    dataLayer.push({
                      event: 'book_vehicle_cta',
                      eventAction: props.fields?.BookiQubeCta?.value?.text,
                      BrandName: props.fields?.BookiQubeCta?.value?.text,
                      VariantName: brandName,
                    })
                  }
                >
                  {props.fields?.BookiQubeCta?.value?.text}
                </a>

                <a
                  href={props.fields?.TestRideCta?.value?.href}
                  className="header-button test-button"
                  target="_self"
                  rel="noopener noreferrer"
                  onClick={() =>
                    dataLayer.push({
                      event: 'test_ride_click',
                      eventAction: props.fields?.TestRideCta?.value?.text,
                      BrandName: props.fields?.TestRideCta?.value?.text,
                      VariantName: brandName,
                    })
                  }
                >
                  {props.fields?.TestRideCta?.value?.text}
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {/* <RequestCallBack isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} /> */}
      <Placeholder
        name="request-callback-popup"
        rendering={props.sitecoreContext.route}
        isPopupOpen={isPopupOpen}
        onPopupClose={() => setIsPopupOpen(false)}
      />
    </section>
  );
};

export default withSitecoreContext()(React.memo(HeaderSection));
